module.exports = __webpack_public_path__ + "media/images/logo-enquirer-w-15639b0fd1e020c11e125b12185ca3db.png";